import type { LifeItem } from '../models'
import { occursOnDate } from './recurrence'

export interface UpcomingAnniversary {
  item: LifeItem
  date: Date
  daysLeft: number
}

function addDays(date: Date, amount: number): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount)
}

export function getUpcomingAnniversaries(items: LifeItem[], today: Date, limit = 3): UpcomingAnniversary[] {
  const anniversaries = items.filter((item) => item.kind === 'anniversary')
  const upcoming: UpcomingAnniversary[] = []

  for (const item of anniversaries) {
    for (let daysLeft = 0; daysLeft <= 400; daysLeft += 1) {
      const date = addDays(today, daysLeft)
      if (!occursOnDate(item, date)) continue
      upcoming.push({ item, date, daysLeft })
      break
    }
  }

  return upcoming
    .sort((left, right) => left.daysLeft - right.daysLeft || left.item.title.localeCompare(right.item.title, 'ko'))
    .slice(0, limit)
}

export function formatDday(daysLeft: number): string {
  return daysLeft === 0 ? 'D-Day' : `D-${daysLeft}`
}
